const isProd = process.env.NODE_ENV === 'production';

const safeConsole = typeof console !== 'undefined' ? console : null;

const logger = {
  debug: (...args: any[]) => {
    if (!isProd && safeConsole && safeConsole.debug) safeConsole.debug(...args);
  },
  info: (...args: any[]) => {
    if (safeConsole && safeConsole.info) safeConsole.info(...args);
  },
  warn: (...args: any[]) => {
    if (safeConsole && safeConsole.warn) safeConsole.warn(...args);
  },
  error: (...args: any[]) => {
    if (safeConsole && safeConsole.error) safeConsole.error(...args);
  },
};

export default logger;
